/** HWYAH corporate mark — copied from my.x9.app so the two footers match. */
import {
  hwyahPaths as hwyahPathsRaw,
  hwyahViewBox as hwyahViewBoxRaw,
  hwyahBrandRed as hwyahBrandRedRaw,
} from '@x9/brand-assets/logo-data';

const hwyahPaths = hwyahPathsRaw as string[];
const hwyahViewBox = hwyahViewBoxRaw as string;
const hwyahBrandRed = hwyahBrandRedRaw as string;

type Props = {
  className?: string;
  title?: string;
  monochrome?: boolean;
};

export default function HwyahLogo({ className, title = 'HWYAH', monochrome = false }: Props) {
  const fill = monochrome ? 'currentColor' : hwyahBrandRed;
  return (
    <svg
      viewBox={hwyahViewBox}
      className={className}
      role="img"
      aria-label={title}
      preserveAspectRatio="xMidYMax meet"
    >
      {hwyahPaths.map((d) => (
        <path key={d.slice(0, 24)} d={d} fill={fill} />
      ))}
    </svg>
  );
}
